import { useState } from 'react';
import AdminLayout from '../../components/Layout/AdminLayout';
import { api } from '../../services/api';
import { getAppYear } from '../../utils/appYear';

export default function AdminStatisticsPage() {
  const currentYear = getAppYear();
  const [year, setYear] = useState<number>(currentYear);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.admin.downloadStatistics(year);
      if (!res.ok) {
        const body = await res.json().catch(() => ({ message: 'Ismeretlen hiba' }));
        throw new Error((body as { message?: string }).message ?? 'Ismeretlen hiba');
      }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `statisztika-${year}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Letöltési hiba');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
    <div className="p-8 max-w-xl">
      <h1 className="text-2xl font-bold mb-6">Statisztikai adatok letöltése</h1>

      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Pályázati év
          </label>
          <select
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
            className="border border-gray-300 rounded-lg px-3 py-2 text-sm w-32 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {/* Show the last 3 years + current */}
            {[0, 1, 2, 3].map((offset) => {
              const y = currentYear - offset;
              return (
                <option key={y} value={y}>
                  {y}
                </option>
              );
            })}
          </select>
        </div>

        <p className="text-sm text-gray-500">
          Az exportált XLSX tartalmazza az összes beküldött pályázatot a kiválasztott évre:
          cégnév, beküldés ideje, méret, térség, tagozat, adószám, pályázó típusa és
          kapcsolattartói adatok.
        </p>

        {error && (
          <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
            {error}
          </p>
        )}

        <button
          onClick={handleDownload}
          disabled={loading}
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors"
        >
          {loading ? (
            <>
              <svg className="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              Letöltés…
            </>
          ) : (
            <>
              <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
              </svg>
              XLSX letöltése ({year})
            </>
          )}
        </button>
      </div>
    </div>
    </AdminLayout>
  );
}
